import { render, staticRenderFns } from "./social-share.vue?vue&type=template&id=0a220fcc&scoped=true&"
import script from "./social-share.vue?vue&type=script&lang=js&"
export * from "./social-share.vue?vue&type=script&lang=js&"
import style0 from "./social-share.vue?vue&type=style&index=0&id=0a220fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a220fcc",
  null
  
)

export default component.exports